/** A new slip. Nothing is written -- and no number is spent -- until the first Post. */
import { COLOR_SORT_FORM } from "@nexseed/shared";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { FormPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { ColorSortPage } from "@/features/processing/components/color-sort-page";

export const Route = createFileRoute("/_app/processing/color-sort/new")({
  beforeLoad: () => {
    if (!useAuth.getState().canCreateForm(COLOR_SORT_FORM))
      throw redirect({ to: "/processing/color-sort" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <FormPageSkeleton />;
  return (
    <ColorSortPage
      slip={null}
      facilityId={selected?.id}
      plantName={selected ? `${selected.name} (${selected.plantCode})` : null}
    />
  );
}
